var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlagCzech(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circleView"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circleView)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 50,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 50,
    width: 100,
    height: 50,
    fill: "#D7141A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,8 50,50 0,92",
    fill: "#11457E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagCzech);
export default __webpack_public_path__ + "static/media/icon_flag_czech.bb4b4b2039f6647c78a0a0e261d392a9.svg";
export { ForwardRef as ReactComponent };